import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import KmxArrowRightFilled from '@kmx/mui-icons/KmxArrowRightFilled';
import { ANALYTICS_CONSTANTS, trackEDDL } from '../../../../../utilities/analytics';
import { ITrackingPayload } from '../../../../../types/analytics';

interface PromoTileProps {
    backgroundImage?: string;
    text: string;
    buttonText: string;
    buttonHref: string;
    trackingPayload: ITrackingPayload;
}

const handleTagging = (e: React.MouseEvent<HTMLAnchorElement>, trackingPayload: ITrackingPayload) => {
    e.preventDefault();

    setTimeout(() => {
        const href = (e.target as HTMLAnchorElement).getAttribute('href');
        if (href) {
            window.location.href = href;
        }
    }, ANALYTICS_CONSTANTS.TRACKING_DELAY);

    trackEDDL(trackingPayload);
};

const PromoTile = ({ backgroundImage, text, buttonText, buttonHref, trackingPayload }: PromoTileProps) => (
    <Box
        sx={{
            minHeight: '12.75rem',
            backgroundColor: 'black',
            backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            borderRadius: '1.5rem',
            flex: 1,
            py: 3,
            px: 4,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        }}
    >
        <Stack spacing={2}>
            <Typography variant="h5" component="h2" color="white" sx={{ width: '16.5rem' }}>
                {text}
            </Typography>
            <Button
                size="large"
                variant="outlined"
                sx={{ color: 'white', borderColor: 'white', width: 'max-content' }}
                href={buttonHref}
                onClick={(e) => handleTagging(e, trackingPayload)}
                endIcon={<KmxArrowRightFilled />}
            >
                {buttonText}
            </Button>
        </Stack>
    </Box>
);

export default PromoTile;
